"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.continentsAll = void 0;
const continentsAll = [
    {
        "id": "1",
        "name": "Europe"
    },
    {
        "id": "9",
        "name": "Asia"
    },
    {
        "id": "10",
        "name": "Africa"
    },
    {
        "id": "11",
        "name": "North America"
    },
    {
        "id": "12",
        "name": "Oceania"
    },
    {
        "id": "13",
        "name": "South America"
    }
];
exports.continentsAll = continentsAll;
//# sourceMappingURL=continents.js.map